/**
 * Constructores de las rutas internas del sitio.
 *
 * Las URL son legibles a proposito: es lo comprometido en `SEO-01`. Estan aca y
 * no sueltas en los componentes para que cambiar el patron de una URL sea un
 * cambio de una linea y no una caceria por todo el proyecto.
 */

export const rutas = {
  inicio: () => '/',
  linea: (slug: string) => `/linea/${slug}`,
  categoria: (slug: string) => `/categoria/${slug}`,
  producto: (slug: string) => `/producto/${slug}`,
  busqueda: (termino: string) => `/buscar?termino=${encodeURIComponent(termino)}`,
  carro: () => '/carro',
  /** Datos, entrega y documento (CHK-03, CHK-04). Sin parametros: el pedido vive en el navegador. */
  checkout: () => '/checkout',
  /** A donde vuelve el comprador tras pagar en Webpay (PAG-02). */
  confirmacionPedido: (referencia: string) => `/checkout/confirmacion?referencia=${encodeURIComponent(referencia)}`,
  administracion: {
    /** Vista de entrada, fuera del armazon del panel. */
    acceso: () => '/admin/acceso',
    /** Cambio de la propia clave; obligatorio con la clave temporal. */
    clave: () => '/admin/clave',
    panel: () => '/admin',
    portada: () => '/admin/portada',
    productos: () => '/admin/productos',
    productoDetalle: (id: number) => `/admin/productos/${id}`,
    pedidos: () => '/admin/pedidos',
    cotizaciones: () => '/admin/cotizaciones',
    /** Con `desde`, la nueva nace como copia de esa cotizacion. */
    cotizacionNueva: (desde?: number) =>
      desde !== undefined ? `/admin/cotizaciones/nueva?desde=${desde}` : '/admin/cotizaciones/nueva',
    busquedas: () => '/admin/busquedas',
    inventario: () => '/admin/inventario',
    productoNuevo: () => '/admin/productos/nuevo',
    despacho: () => '/admin/despacho',
    administradores: () => '/admin/administradores',
  },
} as const;

/** Agrega el numero de pagina a una ruta de listado, salvo en la primera. */
export function conPagina(ruta: string, pagina: number): string {
  if (pagina <= 1) return ruta;
  const separador = ruta.includes('?') ? '&' : '?';
  return `${ruta}${separador}pagina=${pagina}`;
}
